import R from 'ramda';
import { STATE_NAME } from '../constants';

export default R.prop(STATE_NAME);
